import {
  ChecklistStatus,
  SailorChecklistItem,
  SailorForChecklist,
} from "../types";
import { DocumentData } from "firebase/firestore";
import {
  progressTrackerActionIsComplete,
  progressTrackerCheckIsComplete,
} from "../util";

export const calculateSailorCheckList = (
  sailor: SailorForChecklist | undefined,
  progressTracker: Record<string, unknown> | undefined,
  riskProfile: DocumentData | undefined
): Record<SailorChecklistItem, ChecklistStatus> => {
  const kycAmlConsent = sailor?.kycAmlConsent;
  const openBankingConsent = sailor?.openBankingConsent;
  const idvStatus = riskProfile ? riskProfile["idvStatus"] : undefined;
  const kycAmlStatus = riskProfile ? riskProfile["kycAmlStatus"] : undefined;
  if (!sailor) {
    return {
      personalDetails: "not-applicable",
      incomeDetails: "not-applicable",
      supportingDocumentation: "not-applicable",
      kycAmlConsent: "not-applicable",
      kycAmlDesignation: "not-applicable",
      openBankingConsent: "not-applicable",
      idvUnblocked: "not-applicable",
      idVerified: "not-applicable",
      kycAmlCheckDone: "not-applicable",
    };
  }
  return {
    personalDetails: progressTrackerCheckIsComplete(
      progressTracker,
      "personalInfo"
    ),
    incomeDetails: progressTrackerCheckIsComplete(progressTracker, "income"),
    supportingDocumentation: progressTrackerActionIsComplete(
      progressTracker,
      "supportingDocumentation"
    ),
    kycAmlConsent:
      kycAmlConsent === true || kycAmlConsent === false ? kycAmlConsent : null,
    kycAmlDesignation: kycAmlStatus !== "pending" || null,
    openBankingConsent:
      openBankingConsent === true || openBankingConsent === false ? true : null,
    idvUnblocked: idvStatus && idvStatus !== "blocked" ? true : null,
    idVerified: idvStatus !== "pass" ? null : true,
    kycAmlCheckDone:
      kycAmlStatus === "highRisk" || kycAmlStatus === "lowRisk" ? true : null,
  };
};
